import { render } from "./InputMessage.vue?vue&type=template&id=6fc415f5&scoped=true"
import script from "./InputMessage.vue?vue&type=script&lang=js"
export * from "./InputMessage.vue?vue&type=script&lang=js"

import "./InputMessage.vue?vue&type=style&index=0&id=6fc415f5&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc415f5"]])

export default __exports__